import React from 'react';
import { Check, ArrowRight } from 'lucide-react';

const PricingSection = ({ pricing, socialProof }) => {
  const handleGetStarted = () => {
    // Mock action - would navigate to questionnaire
    alert('Redirecting to diagnostic questionnaire...');
  };

  return (
    <section id="pricing" style={{ background: 'var(--bg-card)', padding: '120px 0' }}>
      <div className="container">
        <div style={{ marginBottom: '80px', textAlign: 'center' }}>
          <h2 className="heading-2" style={{ color: 'var(--text-primary)', marginBottom: '24px' }}>
            CLARITY FOR LESS THAN A COFFEE RUN
          </h2>
          <p className="body-medium" style={{ color: 'var(--text-secondary)', maxWidth: '700px', margin: '0 auto' }}>
            {pricing.valueStatement}
          </p>
        </div>

        {/* Social Proof Stats */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '60px',
            marginBottom: '60px',
            flexWrap: 'wrap',
          }}
        >
          <div style={{ textAlign: 'center' }}>
            <div
              className="heading-1"
              style={{
                color: 'var(--brand-primary)',
                fontSize: '3rem',
                marginBottom: '8px',
              }}
            >
              {socialProof.parentCount}
            </div>
            <div className="caption" style={{ color: 'var(--text-secondary)' }}>
              Parents Served
            </div>
          </div>
          <div style={{ textAlign: 'center' }}>
            <div
              className="heading-1"
              style={{
                color: 'var(--brand-primary)',
                fontSize: '3rem',
                marginBottom: '8px',
              }}
            >
              {socialProof.schoolsCovered}
            </div>
            <div className="caption" style={{ color: 'var(--text-secondary)' }}>
              Schools Covered
            </div>
          </div>
          <div style={{ textAlign: 'center' }}>
            <div
              className="heading-1"
              style={{
                color: 'var(--brand-primary)',
                fontSize: '3rem',
                marginBottom: '8px',
              }}
            >
              {socialProof.avgSaving}
            </div>
            <div className="caption" style={{ color: 'var(--text-secondary)' }}>
              Avg. Savings Identified
            </div>
          </div>
          <div style={{ textAlign: 'center' }}>
            <div
              className="heading-1"
              style={{
                color: 'var(--brand-primary)',
                fontSize: '3rem',
                marginBottom: '8px',
              }}
            >
              {socialProof.satisfactionRate}
            </div>
            <div className="caption" style={{ color: 'var(--text-secondary)' }}>
              Satisfaction Rate
            </div>
          </div>
        </div>

        {/* Pricing Card */}
        <div style={{ maxWidth: '600px', margin: '0 auto' }}>
          <div
            style={{
              background: 'var(--bg-card)',
              border: '3px solid var(--brand-primary)',
              borderRadius: '12px',
              padding: '60px 48px',
              textAlign: 'center',
              boxShadow: '0 8px 32px rgba(232, 93, 53, 0.12)',
            }}
          >
            <div
              style={{
                fontSize: '4rem',
                fontWeight: '900',
                color: 'var(--brand-primary)',
                marginBottom: '16px',
                fontFamily: "'PP Right Grotesk', Arial, sans-serif",
                lineHeight: '1',
              }}
            >
              {pricing.price}
            </div>
            <p className="body-medium" style={{ color: 'var(--text-secondary)', marginBottom: '40px' }}>
              {pricing.description}
            </p>

            {/* Features List */}
            <div style={{ textAlign: 'left', marginBottom: '40px' }}>
              {pricing.features.map((feature) => (
                <div
                  key={feature}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '16px',
                    marginBottom: '16px',
                  }}
                >
                  <div
                    style={{
                      width: '24px',
                      height: '24px',
                      background: 'var(--brand-primary)',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0,
                    }}
                  >
                    <Check size={16} color="var(--text-inverse)" />
                  </div>
                  <span className="body-small" style={{ color: 'var(--text-primary)' }}>
                    {feature}
                  </span>
                </div>
              ))}
            </div>

            <button onClick={handleGetStarted} className="btn-primary" style={{ width: '100%' }}>
              Get Started Now
              <ArrowRight size={20} style={{ marginLeft: '8px' }} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
